// PaginationData class as provided in the example
export class PaginationData {
  constructor(pages, currentPage, elements, totalElements, filters) {
    this.pages = pages || 0;
    this.currentPage = currentPage || 0;
    this.elements = elements || 0;
    this.totalElements = totalElements || 0;
    this.filters = filters || {};
  }
}

// UserData class to represent individual user data
export class UserData {
  constructor({ cassiopeaUserId, name, surname, company, role,lastLoginTimestamp }) {
    this.id = cassiopeaUserId || "";
    this.name = name || "";
    this.surname = surname || "";
    this.company = company || "";
    this.role = role || "";
    this.lastLoginTimestamp=lastLoginTimestamp || null;
  }
}

// UsersResponse class to handle the overall response
export class UsersResponse {
  constructor(response) {
    const { pages, currentPage, elements, totalElements, filters, data } =
      response;
    this.pagination = new PaginationData(
      pages,
      currentPage,
      elements,
      totalElements,
      filters ? filters : {}
    );
    this.data = data && data.length > 0 ? data.map(user => new UserData(user)) : [];
  }
}

// Example usage:
export const responseJSON = {
  pages: 2,
  currentPage: 1,
  elements: 10,
  totalElements: 20,
  filters: {
    search: "John Doe",
  },
  data: [
    {
      "cassiopeaUserId": "1",
      "name": "John",
      "surname": "Doe",
      "company": "Company A",
      "role": "INSTALLER"
    },
    {
      "cassiopeaUserId": "2",
      "name": "Jane",
      "surname": "Smith",
      "company": "Company B",
      "role": "ADMIN"
    },
    {
      "cassiopeaUserId": "3",
      "name": "Alice",
      "surname": "Johnson",
      "company": "Company C",
      "role": "INSTALLER"
    },
    {
      "cassiopeaUserId": "4",
      "name": "Bob",
      "surname": "Williams",
      "company": "Company D",
      "role": "ADMIN"
    },
    {
      "cassiopeaUserId": "5",
      "name": "Charlie",
      "surname": "Brown",
      "company": "Company E",
      "role": "INSTALLER"
    },
    {
      "cassiopeaUserId": "6",
      "name": "David",
      "surname": "Miller",
      "company": "Company F",
      "role": "ADMIN"
    },
    {
      "cassiopeaUserId": "7",
      "name": "Eve",
      "surname": "Davis",
      "company": "Company G",
      "role": "INSTALLER"
    },
    {
      "cassiopeaUserId": "8",
      "name": "Frank",
      "surname": "Wilson",
      "company": "Company H",
      "role": "ADMIN"
    },
    {
      "cassiopeaUserId": "9",
      "name": "Grace",
      "surname": "Moore",
      "company": "Company I",
      "role": "INSTALLER"
    },
    {
      "cassiopeaUserId": "10",
      "name": "Hank",
      "surname": "Taylor",
      "company": "Company J",
      "role": "ADMIN"
    }
  ],
};

const usersResponse = new UsersResponse(responseJSON);

console.log(usersResponse);
